<div class="tabellarische-maske">
    <lib-tabellarische-maske-title>{{
        'ABWEICHUNGEN_MELDEN_SZ_25' | translate
    }}</lib-tabellarische-maske-title>
    <span
        [innerHTML]="
            'TABELLARISCHE_MASKE_ERKLAERUNG'
                | translate
                    : {
                          kindName: dialogData.templateVariables.kindName,
                          institutionName:
                              dialogData.templateVariables.institutionName
                      }
        "
    >
    </span>
    <form (ngSubmit)="uebernehmen()">
        <lib-tabellarische-maske-table>
            <tr tabellarische-maske-table-header>
                <th>{{ 'MONTH' | translate }}</th>
                <th>
                    <span>{{
                        'TOTAL_BETREUUNGSPENSUM_TAGEN' | translate
                    }}</span>
                    <lib-tooltip-x
                        [text]="'TOTAL_BETREUUNGSPENSUM_TAGEN_HELP' | translate"
                    ></lib-tooltip-x>
                </th>
                <th>{{ 'MONATLICHE_BETREUUNGSKOSTEN' | translate }}</th>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>8.{{ gpData.firstYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().AUGUST.pensumInTage"
                        name="pensum-august"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().AUGUST.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-august"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>9.{{ gpData.firstYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().SEPTEMBER.pensumInTage"
                        name="pensum-september"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().SEPTEMBER.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-september"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>10.{{ gpData.firstYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().OCTOBER.pensumInTage"
                        name="pensum-oktober"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().OCTOBER.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-oktober"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>11.{{ gpData.firstYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().NOVEMBER.pensumInTage"
                        name="pensum-november"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().NOVEMBER.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-november"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>12.{{ gpData.firstYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().DECEMBER.pensumInTage"
                        name="pensum-december"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().DECEMBER.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-december"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>01.{{ gpData.secondYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().JANUARY.pensumInTage"
                        name="pensum-january"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().JANUARY.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-january"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>02.{{ gpData.secondYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().FEBRUARY.pensumInTage"
                        name="pensum-february"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().FEBRUARY.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-february"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>03.{{ gpData.secondYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().MARCH.pensumInTage"
                        name="pensum-march"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().MARCH.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-march"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>04.{{ gpData.secondYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().APRIL.pensumInTage"
                        name="pensum-april"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().APRIL.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-april"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>05.{{ gpData.secondYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().MAY.pensumInTage"
                        name="pensum-may"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().MAY.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-may"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>06.{{ gpData.secondYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().JUNE.pensumInTage"
                        name="pensum-june"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().JUNE.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-june"
                        class="form-control"
                    />
                </td>
            </tr>
            <tr tabellarische-maske-table-body>
                <td>07.{{ gpData.secondYear }}</td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="abschnitte().JULY.pensumInTage"
                        name="pensum-july"
                        class="form-control"
                    />
                </td>
                <td>
                    <input
                        (keydown)="InputUtil.blockInvalidChars($event)"
                        type="number"
                        [(ngModel)]="
                            abschnitte().JULY.monatlicheBetreuungskosten
                        "
                        name="monatliche-betreuungskosten-july"
                        class="form-control"
                    />
                </td>
            </tr>
        </lib-tabellarische-maske-table>

        <div class="tabellarische-maske-actions">
            <button class="dv-btn">
                {{ 'UEBERNEHMEN' | translate }}
            </button>
            <button
                class="dv-btn cancel-button"
                type="button"
                (click)="cancel()"
            >
                {{ 'CANCEL' | translate }}
            </button>
        </div>
    </form>
</div>
